<template>
  <PageTerms v-bind="{ terms }" />
</template>

<script setup>
const terms = {
  name: "Contest Policy",
  lastUpdated: "1st January 2024",
  content: [
    {
      heading: "Eligibility",
      clauses: [
        "Contests are open to legal residents of Argentina, Australia, Austria, Andorra, Bangladesh, Belgium, Brazil, Bulgaria, Canada, Chile, China, Colombia, Costa Rica, Croatia, Cyprus, Czech Republic, Denmark, Egypt, Estonia, Finland, France, Georgia, Germany, Ghana, Gibraltar, Greece, Hong Kong, Hungary, Iceland, India, Indonesia, Ireland, Israel, Italy, Japan, Kenya, Latvia, Liechtenstein, Lithuania, Luxembourg, Malaysia, Malta, Mexico, Monaco, Morocco, Nepal, Netherlands, New Zealand, Norway, Pakistan, Philippines, Poland, Portugal, Romania, San Marino, Singapore, Slovakia, Slovenia, South Africa, South Korea, Sri Lanka, Spain, Sweden, Switzerland, Tanzania, Thailand, Turkey, Uganda, Ukraine, United Arab Emirates, United Kingdom, United States of America, Uruguay, Vietnam, and Zambia, who are over the age of 14 when entering the contest.",
        "Entrants under the age of 18 may need to gain permission from their parent or legal guardian in order to claim their prizes.",
        "Titles awarded Gold or Silver are not eligible to participate again within a period of 12 months.",
      ],
    },
    {
      heading: "Contest cycle",
      clauses: [
        "The contest starts on the 1st day of month 1.",
        "Stats accumulate and count towards the ranking for 28 days after the day of publication of the chapter(s).",
        "Once a chapter accumulates 1000 views, its title is entered into the contest.",
        "From the 2nd day, the ranking of participating titles is displayed, and is updated daily.",
        "The last day of month 1 is the final day on which a title can be entered into the contest for that month.",
        "All stats stop accumulating for titles on the 28th day of month 2, and the ranking is settled.",
        "Winners are announced on the contest page and social media on the 14th day of month 3.",
        "Prizes will have been distributed to winners by the end of month 3.",
        "The contest repeats monthly until further notice.",
      ],
    },
    {
      heading: "Conditions",
      clauses: [
        "Titles can be a manga, manhua, manhwa, vertical long strip or western comic.",
        "Titles must be in one of the following languages: English, Spanish, Portuguese, Italian, French, German, Japanese, Chinese or Korean.",
        "Chapters must be at least 9 pages in length (each) and can either be a complete story or part of one. Title pages must be included within the total number of pages. Each page must be A4 in dimensions or thereabouts.",
        "Manga, manhua, manhwa can be drawn in either right-to-left (traditional) or left-to-right (western). The direction can be specified upon title creation.",
        "Chapters can be submitted in either black-and-white or in color.",
        "There must be some semblance of a story within the chapter.",
        "The participant MUST own the rights to the title submitted. We reserve the right to ask for proof of creation as a condition for winning.",
        "Titles are automatically entered into the contest when at least one chapter accumulates at least 1000 views in the relevant 28-day period.",
      ],
    },
    {
      heading: "Judging criteria",
      clauses: [
        "Titles will be judged based on the ranking, which is calculated by aggregating and scoring the number of views, followers and comments a submitted title has.",
        "Only the first three chapters count towards the ranking.",
        "Titles with multiple languages will be aggregated.",
        "We reserve the right to make adjustments if we detect irregularities with any of the stats.",
      ],
    },
    {
      heading: "Content Guidelines",
      clauses: [
        "The <a href='/en/terms/content' class='underline text-nami-nami-blue'>Content Guidelines</a> also apply to titles entering the contest. ",
      ],
    },
    {
      heading: "Ineligibility",
      clauses: [
        "Titles which do not meet the eligibility critera will not be considered. ",
        "Titles which violate the content guidelines will be disqualified. ",
        "Employees of NamiComi and their families are not eligible to enter the contest. ",
      ],
    },
    {
      heading: "Prizes",
      clauses: [
        "The four prizes are described below:",
        {
          subheading: "Gold Chest (1st place)",
          subclauses: [
            "NamiComi offers, through a partner, to translate the first 3 chapters of the title to all supported languages (currently English, Spanish, Portuguese, Italian, Japanese and Korean - we may add or remove languages at our discretion). ",
          ],
        },
        {
          subheading: "Silver Chest (2nd place)",
          subclauses: [
            "NamiComi offers, through a partner, to translate the first 3 chapters of the title to two supported languages of your choice. ",
          ],
        },
        {
          subheading: "Bronze Chest (3rd place)",
          subclauses: [
            "NamiComi offers, through a partner, to translate the first 3 chapters of the title to one supported language of your choice. ",
          ],
        },
        "Prizes are non-exchangeable, non-returnable and non-transferable.",
        "In order to claim a prize, the creator must complete all the required steps to set up their organization's payment profile via Stripe.",
      ],
    },
  ],
};

const config = useRuntimeConfig();
const title = ref("Contest Policy");
const canonical = ref(`${config.public.baseUrl}/en/terms/contest`);
definePageMeta({ title: "Contest Policy" });

useHead({
  title: title,
  link: [{ rel: "canonical", href: canonical }],
  meta: [
    {
      property: "og:title",
      content: `${title.value} - ${config.public.siteName}`,
    },
  ],
});
</script>
